import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region major store
let store = (set) => ({
  // store majors
  majors: {},
  // store major count
  majorCount: 0,
  // get All majors
  getMajors: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'major.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/major`, config)
    set(async (state) => {
      // initilize majors state variable to the responsed majors if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.majors = apiResponse.data
    })
  },
  getMajorCount: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/major/getcount`, config)
    set(async (state) => {
      // initilize majors state variable to the responsed majors if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.majorCount = apiResponse?.data?.major??''
    })
  },
  addMajor: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/major`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing majors state variable to the resoponsed data
        state.majors = {
          data: [apiResponse.data, ...state.majors.data],
          limit: state.majors.limit,
          page: state.majors.page,
          totalCount: state.majors.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editMajor: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/major/${id}`, payload, config)
    // update majors state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.majors?.data?.find((major, index) => {

          if (major.id === id) {
            state.majors.data[index] = apiResponse?.data
          }
        })

        state.majors = {
          data: [...state.majors.data],
          limit: state.majors.limit,
          page: state.majors.page,
          totalCount: state.majors.totalCount,
        }
      })
    }
    return apiResponse
  },
  deleteMajor: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/major/${id}`, config)
    // delete element in the majors.data array state if the request was succeed
    if (apiResponse?.status === 200) {

      set(async (state) => {
        const arr = state.majors.data.filter(item => item.id !== id)
        state.majors = {
          data: arr,
          limit: state.majors.limit,
          page: state.majors.page,
          totalCount: state.majors.totalCount - 1,
        }
      })

    }

    return apiResponse

  },
})
//#endregion major store

// store the state in the browser local storage
// store = persist(store, { name: 'major' })

// getting store data in the browser localstorage
const major_Store = create(store)

export default major_Store
